import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';





class Projects extends React.Component {

    render() {
        return (
            <div className='home'>

 <h2>Line-Locking in the Broad Absorption Line Region of Quasars</h2>
                <p>
                Line-locking is a phenomenon observed in AGN when an absorption doublet couples with another iteration of the same such that the higher frequency line of one overlaps with the lower frequency line of the other in the observed spectrum.  This is a common configuration for C IV when multiple doublets appear in the same system.  Line-locking is the result of line-driven radiation pushing one cloud in the outflow into a synchronous configuration with another.  However, the problem is dependent on the metallicity, ionization, and density of each cloud, in addition to the kinematic arrangement.  We simulate the system by coupling Cloudy software (Ferland et al.) with a time-dependent kinematic model.  Preliminary results suggest that it is possible to produce stable line-locking (i.e. under some cloud configurations, a range of kinematic inputs lead to the clouds “locking” together in velocity space over a significant period of time relative to the dynamic and source variability timescales).  This problem has confounded theoretical astrophysicists for several decades and our upcoming article should make an impact.
                </p>
     <h2>Observing Active Galactic Nuclei at the George Wise Observatory</h2>
                <p>            
                I orchestrated an ongoing radio-quiet AGN monitoring campaign at the Wise Observatory, using narrow band spectroscopic photometry to monitor the continuum for accretion disk reverberation mapping.  The technique is new, having been applied to only one published source, but will provide unprecedented observational information about the size of the accretion disk in AGN, which may be significantly larger than simple theoretical predictions (Shakura & Sunyaev, 1979).  I also monitored a subset of radio-loud AGN in the same fashion to test the methodology and confirm the BH mass/accretion disk size relation.  This technique could also be used on any instrument with narrow band optical/UV filters that can monitor an object nightly for 1-4 months.
</p>

            </div>
        );
    }
}

const styles = theme => ({
  root: {
    maxWidth: 400,
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    paddingLeft: theme.spacing.unit * 4,
    backgroundColor: theme.palette.background.default,
  },
  img: {
    display: 'block',
    overflow: 'hidden',
    width: '100%',
  },
});

Projects.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Projects);



// WEBPACK FOOTER //
// ./src/Components/AGNTheory.js